import React from 'react';

export default ({ label, handleChange, name, required = false, id, dark = false, values = [] }) => {



    return <div className="mb-3">
        {
            dark
                ? <label className="form-label text-white fw-bold" style={{ textShadow: '1px 1px 0px black' }} htmlFor={id}>{label}</label>
                : <label className="form-label text-primary fw-bold" htmlFor={id}>{label}</label>
        }

        <select name={name} id={id} onChange={handleChange} defaultValue={null} required={required} className='form-control form-control-lg'>
            <option value={null}> -- -- </option>
            {
                values !== null
                    ? values.map((value, idx) => <option key={idx} value={value.id}>{value.name}</option>)
                    : null
            }
        </select>
    </div>
};
